import { RouteObject } from 'react-router-dom';
import { RoutesEnum } from '~/constants/enums';
import InitializeAddListing from '~addListing/pages/InitializeStep';
import ListingDescription from '~addListing/pages/ListingDescription';
import DetailsStep from '~addListing/pages/DetailsStep';
import ListingMediaStep from '~addListing/pages/ListingMediaStep';
import ListingPublishStep from '~/modules/addListing/pages/ListingPublishStep';
import PriceStep from '~addListing/pages/PriceStep';

export const addListingRoutes: RouteObject[] = [
  {
    path: RoutesEnum.INITIALIZE,
    element: <InitializeAddListing />,
  },
  {
    path: `:id/${RoutesEnum.EDIT}`,
    element: <ListingDescription />,
  },
  {
    path: `:id/${RoutesEnum.DETAILS}`,
    element: <DetailsStep />,
  },
  {
    path: `:id/${RoutesEnum.PRICE}`,
    element: <PriceStep />,
  },
  {
    path: `:id/${RoutesEnum.PHOTOS}`,
    element: <ListingMediaStep />,
  },
  {
    path: `:id/${RoutesEnum.PUBLISH}`,
    element: <ListingPublishStep />,
  },
];
